export const configControlZoneDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/airport.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configControlZoneLayer = {
  "Name": "ControlZone",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": {
      "Point": [{
        "style": {
          "default": {
            "type": "circle",
            "line_color": "#0000ff",
            "fill_color": "rgba(0,0,0,0)",
            "line_width": 2,
            "line_dash": [15, 4],
          }
        }
      }],
      "Polygon": [{
        "style": {
          "default": {
            "line_color": "#0000ff",
            "fill_color": "rgba(0,0,0,0)",
            "line_width": 2,
            "line_dash": [15, 4],
          }
        }
      }]
    }
  }
}